import React from 'react';
import './Tankreinigung.css';
import { useNavigate } from 'react-router-dom';

const TankReinigung = () => {

    const navigate = useNavigate();
    const handleNavigationContact = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('contact');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
      }

    return (
        <div className="tankreinigung-container">
            <h1 className="tankreinigung-title">Professionelle Tankreinigung</h1>
            <p className="tankreinigung-description">
                Wir bieten einen umfassenden Service zur Vorbereitung und Lackierung von Flüssiggasbehältern an, wobei wir sicherstellen, 
                dass jeder Schritt den höchsten Qualitäts- und Sicherheitsstandards entspricht. 
            </p>
            
            <div className='tankreinigung-steps'>
                <h2>Phasen der Lackierung von Flüssiggasbehältern</h2>
                <p>
                    Hier sind die Phasen, die wir bei der Lackierung des Behälters durchführen:
                </p>
                <ol>
                    <li>
                        <span className='bolded'>Oberflächenvorbereitung: </span><be/>
                        Zunächst entfernen wir alle Rückstände oder Verschmutzungen von der Oberfläche des Behälters, um eine gute Haftung des Lacks zu gewährleisten.
                    </li>
                    <li>
                        <span className='bolded'>Rost- und Schadensbeseitigung: </span><be/>
                        Wir verwenden spezialisierte Techniken, um Rost und Mängel wie Dellen und Kratzer vollständig zu entfernen, sodass die Oberfläche glatt und bereit für die Lackierung ist.
                    </li>
                    <li>
                        <span className='bolded'>Reinigung der Oberfläche: </span><be/>
                        Nach der Entfernung von Rost und Mängeln reinigen wir den Behälter gründlich, um verbleibende Partikel mit geeigneten Reinigungsmitteln zu entfernen.
                    </li>
                    <li>
                        <span className='bolded'>Auftragen der Grundierung (Grunderung): </span><be/>
                        Wir tragen eine hochwertige Grundierung auf, die als Schutzbarriere gegen Korrosion dient und die Haftung des Lacks verbessert.
                    </li>
                    <li>
                        <span className='bolded'>Lackierung des Behälters: </span><be/>
                        Nachdem die Grundierung getrocknet ist, tragen wir eine spezielle Lackierung für Metall auf, die wetterbeständig und schnell trocknend ist. Wir verwenden hochwertige Farben, um einen dauerhaften Schutz des Behälters zu gewährleisten.
                    </li>
                    <li>
                        <span className='bolded'>Qualitätsprüfung: </span><be/>
                        Nach dem Lackieren führen wir eine umfassende Prüfung durch, um sicherzustellen, dass alles korrekt durchgeführt wurde und der Lack vollständig getrocknet ist.
                    </li>
                    <li>
                        <span className='bolded'>Anbringen der Sicherheitsaufkleber: </span><be/>
                        In der letzten Phase kleben wir das Namensschild der Firma, die den Behälter besitzt, sowie die Sicherheitsaufkleber an, die wichtige Sicherheitsanweisungen enthalten, um die Einhaltung der Umwelt- und Sicherheitsstandards zu gewährleisten.
                    </li>
                </ol>
            </div>
            <div className='tankreinigung-dienstleitungen'>
                <h2>Warum sollten Sie unsere Dienstleistungen wählen</h2>
                <p>
                    Hohe Qualität: Wir verwenden die besten Materialien und Techniken, um ausgezeichnete Ergebnisse zu erzielen.
                    
                    Erfahrenes und professionelles Team: Unser Team verfügt über die erforderlichen Fähigkeiten und Erfahrungen, um die Arbeit auf höchstem Niveau durchzuführen.
                    
                    Sicherheit und Schutz: Wir nehmen die Sicherheit ernst und arbeiten nach den strengsten Standards.
                </p>
            </div>
            <div className="tankreinigung-contact">
                <p>Für weitere Informationen oder zur Terminvereinbarung kontaktieren Sie uns:</p>
                <button className="contact-button" onClick={handleNavigationContact}>Kontakt aufnehmen</button>
            </div>
        </div>
    );
};

export default TankReinigung;